module.exports = __webpack_public_path__ + "img/image11.7ccaa6c4.png";